/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/styles/sections/opk-main-register.scss":
/*!****************************************************!*\
  !*** ./src/styles/sections/opk-main-register.scss ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://acrylic_one/./src/styles/sections/opk-main-register.scss?");

/***/ }),

/***/ "./src/scripts/sections/opk-main-register.js":
/*!***************************************************!*\
  !*** ./src/scripts/sections/opk-main-register.js ***!
  \***************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_opk_main_register_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/opk-main-register.scss */ \"./src/styles/sections/opk-main-register.scss\");\n\nconst assignFormChange = () => {\n  const button = document.querySelector('[opk-data-change-form-button]');\n  const forms = document.querySelectorAll('[opk-data-form]');\n  const texts = button.querySelectorAll('[opk-data-button-text]');\n  button.addEventListener('click', () => {\n    forms.forEach(el => {\n      el.classList.toggle('opk-dn');\n    });\n    texts.forEach(el => {\n      el.classList.toggle('opk-dn');\n    });\n  });\n};\nconst assignVatCheck = () => {\n  const container = document.querySelector('[opk-data-company-form]');\n  const input = container.querySelector('[opk-data-company-vat]');\n  const errorMessage = container.querySelector('[data-vat-error-message]');\n  const successMessage = container.querySelector('[data-vat-success-message]');\n  const button = container.querySelector('[opk-data-submit-company]');\n  input.addEventListener('input', async () => {\n    if (!input.value) {\n      errorMessage.classList.add('visible');\n      successMessage.classList.remove('visible');\n      button.disabled = true;\n      return;\n    }\n    const value = input.value.split(' ').join('');\n    const pattern = /^(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})$/;\n    let valid = pattern.test(value);\n    if (!valid) {\n      console.log('blya');\n      const res = await fetch(`https://controleerbtwnummer.eu/api/validate/${value}.json`);\n      const response = await res.json();\n      valid = response.valid;\n    }\n    console.log('yees');\n    if (valid) {\n      errorMessage.classList.remove('visible');\n      successMessage.classList.add('visible');\n      button.disabled = false;\n    } else {\n      successMessage.classList.remove('visible');\n      errorMessage.classList.add('visible');\n      button.disabled = true;\n    }\n  });\n};\nassignFormChange();\nassignVatCheck();\n\n//# sourceURL=webpack://acrylic_one/./src/scripts/sections/opk-main-register.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/opk-main-register.js");
/******/ 	
/******/ })()
;